"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLine = exports.UserSettingsWrapper = exports.IconWrapper = exports.HorizontalLine2 = exports.ItemWrapper = exports.EmailWrapper = exports.UserNameWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.UserNameWrapper = styled_components_1.default.div `
  font-size: 18px;
  font-weight: bold;
`;
exports.EmailWrapper = styled_components_1.default.div `
  font-size: 15px;
  color: ${colors_1.GREY3};
`;
exports.ItemWrapper = styled_components_1.default.div `
  font-size: 16px;
  color: ${colors_1.GREY3};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 1px;
  &:hover {
    cursor: pointer;
    background-color: ${colors_1.PALE_GREEN};
  }
`;
exports.HorizontalLine2 = styled_components_1.default.hr `
  border: none;
  border-bottom: 1px solid ${colors_1.LIGHT_GREY};
`;
exports.IconWrapper = styled_components_1.default.div `
  cursor: pointer;
  margin-right: 11px;
  padding-top: 0.25rem;
`;
exports.UserSettingsWrapper = styled_components_1.default.div `
  min-width: 15%;
  border: none;
  padding: 13px;
  background: ${colors_1.WHITE};
  box-shadow: 0px -1px 12px rgba(0, 0, 0, 0.06), 0px 15px 16px rgba(0, 0, 0, 0.08), 0px 5px 14px rgba(0, 0, 0, 0.07);
  border-radius: 2px;
  width: fit-content;
`;
exports.HorizontalLine = styled_components_1.default.hr `
  order: 6;
  align-self: stretch;
  flex-grow: 0;
  margin: 8px 0px;
  border: 1px solid ${colors_1.LIGHT_GREY};
  background-color: ${colors_1.LIGHT_GREY};
`;
//# sourceMappingURL=UserSettingsMenu.styles.js.map